<template>
  <div>
    <div class="manager-panel">
      <a-row type="flex" justify="space-between" align="middle">
        <a-col style="flex: 1;">
          <a-dropdown :trigger="['click']" v-model="seachMenuView">
            <a-input-search class="ant-dropdown-link" placeholder="Search" :value="sortActive" />
            <a-menu slot="overlay" style="background-color:#fafafa">
              <a-form id="my_form_search_styl" layout="vertical" style="padding:15px">
                <a-menu-item key="1">
                  <a-form-item label="Data Month" :label-col="{span:8}" :wrapper-col="{span:8}">
                    <a-month-picker
                      v-model="sort.selectData"
                      style="width: 170px; margin-right: auto"
                      placeholder="Select month"
                    />
                  </a-form-item>
                </a-menu-item>
                <a-menu-item key="2">
                  <a-form-item label="Typ przychodu" :label-col="{span:8}" :wrapper-col="{span:8}">
                    <a-select v-model="sort.selectTypPrzychodu" style="width: 170px">
                      <a-select-option
                        v-for="typPrzychodu in selectTypPrzychoduList"
                        :value="typPrzychodu.id"
                        :key="typPrzychodu.id"
                      >{{typPrzychodu.name}}</a-select-option>
                    </a-select>
                    <a-icon
                      style="margin-left: 5px"
                      @click="el => clearSelect('selectTypPrzychodu')"
                      type="delete"
                    />
                  </a-form-item>
                </a-menu-item>
                <a-menu-item key="3">
                  <a-form-item label="Projekt" :label-col="{span:8}" :wrapper-col="{span:8}">
                    <a-select
                      v-model="sort.selectProject"
                      style="width: 170px"
                      show-search
                      placeholder="Select"
                      option-filter-prop="children"
                      :filter-option="filterOption"
                    >
                      <a-select-option
                        v-for="project in selectProject"
                        :value="project.id"
                        :key="project.name"
                      >{{project.name}}</a-select-option>
                    </a-select>
                    <a-icon
                      style="margin-left: 5px"
                      @click="el => clearSelect('selectProject')"
                      type="delete"
                    />
                  </a-form-item>
                </a-menu-item>
                <a-menu-item key="4">
                  <a-form-item label="Opiekun CS" :label-col="{span:8}" :wrapper-col="{span:8}">
                    <a-select
                      v-model="sort.selectOpiekun"
                      style="width: 170px"
                      show-search
                      placeholder="Select"
                      option-filter-prop="children"
                      :filter-option="filterOption"
                    >
                      <a-select-option
                        v-for="user in selectResponsibleList"
                        :value="user.id"
                        :key="user.id"
                      >{{user.name}}</a-select-option>
                    </a-select>
                    <a-icon
                      style="margin-left: 5px"
                      @click="el => clearSelect('selectOpiekun')"
                      type="delete"
                    />
                  </a-form-item>
                </a-menu-item>
                <a-menu-item key="5">
                  <a-form-item
                    label="Specjalista PPC"
                    :label-col="{span:8}"
                    :wrapper-col="{span:8}"
                  >
                    <a-select
                      v-model="sort.selectSpejalista"
                      style="width: 170px"
                      show-search
                      placeholder="Select"
                      option-filter-prop="children"
                      :filter-option="filterOption"
                    >
                      <a-select-option
                        v-for="user in selectAssignedList"
                        :value="user.id"
                        :key="user.id"
                      >{{user.name}}</a-select-option>
                    </a-select>
                    <a-icon
                      style="margin-left: 5px"
                      @click="el => clearSelect('selectSpejalista')"
                      type="delete"
                    />
                  </a-form-item>
                </a-menu-item>
                <a-menu-item key="6">
                  <a-form-item label="Płatnik" :label-col="{span:8}" :wrapper-col="{span:8}">
                    <a-select v-model="sort.selectPlatnik" style="width: 170px">
                      <a-select-option
                        v-for="platnik in selectPlatnik"
                        :value="platnik.id"
                        :key="platnik.id"
                      >{{platnik.name}}</a-select-option>
                    </a-select>
                    <a-icon
                      style="margin-left: 5px"
                      @click="el => clearSelect('selectPlatnik')"
                      type="delete"
                    />
                  </a-form-item>
                </a-menu-item>
                <a-menu-item key="7">
                  <a-form-item label :label-col="{span:8}" :wrapper-col="{span:8}">
                    <div>
                      <a-checkbox v-model="sort.checkOnPlanned">Pokaz tylko niezaplanowane</a-checkbox>
                      <a-checkbox v-model="sort.checkPlanned">Pokaz tylko zaplanowane</a-checkbox>
                    </div>
                  </a-form-item>
                </a-menu-item>
                <a-form-item
                  key="8"
                  style="text-align:center;"
                  :label-col="{span:0}"
                  :wrapper-col="{span:24}"
                >
                  <a-button
                    type="primaty"
                    style="margin: 0 7px;"
                    @click="sortReset"
                  >{{ $t('Reset') }}</a-button>
                  <a-button
                    type="primary"
                    style="margin: 0 7px;"
                    @click="sortMediaList"
                  >{{ $t('Search') }}</a-button>
                </a-form-item>
              </a-form>
            </a-menu>
          </a-dropdown>
        </a-col>
      </a-row>
    </div>
    <a-table
      :scroll="{ x: 2000}"
      :columns="columns"
      :data-source="MediaListSource"
      bordered
    >
      <template slot="rok" slot-scope="text">{{text}}</template>
      <template slot="miesiac" slot-scope="text">{{getMount(text)}}</template>
      <template slot="project" slot-scope="text,record">
        <a
          target="_blank"
          :href="'https://' + domain + '/crm/deal/details/' + record.id + '/' "
        >{{text}}</a>
      </template>
      <template slot="kontrahent" slot-scope="id">{{searchCompany(id)}}</template>
      <template slot="typPrzychodu" slot-scope="id">{{searchTypeArrival(id)}}</template>
      <template slot="platnik" slot-scope="id">{{searchPlatnik(id)}}</template>
      <template slot="specjalista" slot-scope="id">{{searchUser(id)}}</template>
      <template slot="opiekunCS" slot-scope="id">{{searchUser(id)}}</template>
      <template slot="wykonanie" slot-scope="text, record">
        <div v-if="record.editMode" style="display: flex;">
          <a-input
            style="margin: -5px 5px -5px 0; width: 65px"
            :value="text"
            v-model="record.performed"
          />
          <a @click="savePerformed(record.key)">
            <a-icon type="save" style="margin-left: 10px" />
          </a>
        </div>
        <div v-else>
          {{text}}
          <a :disabled="!statusEdit">
            <a-icon type="edit" @click="editPerformed(record.key)" style="margin-left: 10px" />
          </a>
        </div>
      </template>
      <template slot="FVSprzedazowy" slot-scope="text">
        <div>{{text}}</div>
      </template>
      <template slot="button" slot-scope="text, record">
        <div style="display: flex; flex-direction: column; align-items: flex-start">
          <div class="list-invoices">
            <div v-for="item in record.invoices" :key="item.docID">
              <a style="margin: 0 7px 0 0" @click="openInvoice(item)">{{item.invoiceTitle}}</a>
            </div>
          </div>
          <a-button type="primary" style="margin: 9px auto 4px;" @click="openSalesTable(record)">Dodaj</a-button>
        </div>
      </template>
      <template slot="FVKosztowy" slot-scope="text">
        <div>{{text}}</div>
      </template>
      <template slot="podsumowanie" slot-scope="text">
        <div>{{text}}</div>
      </template>
    </a-table>
  </div>
</template>

<script>
import {
  getMediaListSort,
  getMediaListForecastsSort,
  postEditPerformed,
} from "@/requestFunc";
import moment from "moment";
export default {
  name: "approvalMediaForecasts",
  data() {
    return {
      columns: [
        {
          title: "Rok",
          dataIndex: "dataY",
          scopedSlots: { customRender: "rok" },
          width: 70,
        },
        {
          title: this.$t("Month"),
          dataIndex: "dataM",
          scopedSlots: { customRender: "miesiac" },
          width: 110,
        },
        {
          title: this.$t("Project"),
          dataIndex: "project",
          scopedSlots: { customRender: "project" },
          width: 120,
        },
        {
          title: "Kontrahent",
          dataIndex: "kontrahent",
          scopedSlots: { customRender: "kontrahent" },
          width: 200,
        },
        {
          title: "Typ przychodu",
          dataIndex: "typPrzychodu",
          scopedSlots: { customRender: "typPrzychodu" },
          width: 150,
        },
        {
          title: this.$t("Płatnik"),
          dataIndex: "platnik",
          scopedSlots: { customRender: "platnik" },
          width: 200,
        },
        {
          title: "Specjalista PPC",
          dataIndex: "specjalista",
          scopedSlots: { customRender: "specjalista" },
          width: 150,
        },
        {
          title: "Opiekun CS",
          dataIndex: "opiekunCS",
          scopedSlots: { customRender: "opiekunCS" },
          width: 150,
        },
        {
          title: "Plan",
          dataIndex: "plan",
          scopedSlots: { customRender: "plan" },
          width: 110,
        },
        {
          title: "Plan z poprzednim",
          dataIndex: "previousPlan",
          scopedSlots: { customRender: "planZpoprzednim" },
          width: 110,
        },
        {
          title: "Wykonanie",
          dataIndex: "performed",
          scopedSlots: { customRender: "wykonanie" },
          width: 125,
        },
        {
          title: "FV Sprzedażowy",
          dataIndex: "summType",
          scopedSlots: { customRender: "FVSprzedazowy" },
          width: 140,
        },
        {
          title: "Dodaj Sprzedażowe",
          dataIndex: "button",
          scopedSlots: { customRender: "button" },
          width: 210,
        },
        {
          title: "FV Kosztowy",
          dataIndex: "summTypeKoszt",
          scopedSlots: { customRender: "FVKosztowy" },
          width: 140,
        },
        {
          title: "Podsumowanie",
          dataIndex: "summ",
          scopedSlots: { customRender: "podsumowanie" },
          width: 140,
        },
        {
          title: "Komentarz",
          dataIndex: "komentarz",
          scopedSlots: { customRender: "komentarz" },
          width: 140,
        },
      ],
      selectWorker: "",
      selectData: "",
      selectTypPrzychoduList: [],
      selectOpiekun: "",
      selectPlatnik: [],
      selectProject: [],
      MediaListSource: [],
      selectUserList: [],
      sort: {
        selectData: "",
        selectTypPrzychodu: "",
        selectProject: "",
        selectOpiekun: "",
        selectSpejalista: "",
        selectPlatnik: "",
        checkOnPlanned: false,
        checkPlanned: false,
      },
      typeArrival: {},
      seachMenuView: false,
      selectAssignedList: {},
      selectResponsibleList: {},
      statusEdit: false,
      sortActive: "",
    };
  },
  props: [
    "settings",
    "USER_ACTIVE",
    "user_setup",
    "domain",
    "checkFacture",
    "dataFacture"
  ],
  methods: {
    setTypPrzychodu(typArrival) {
      this.selectTypPrzychoduList = typArrival.map((el) => ({
        id: el.ID,
        name: el.VALUE,
      }));
    },
    setPlatnik(platnik) {
      this.selectPlatnik = platnik.map((el) => ({ id: el.ID, name: el.VALUE }));
    },
    setProject(project) {
      this.selectProject = project.map((el) => ({
        id: el.info[0].dealID,
        name: el.info[0].DEAL_TITLE,
      }));
    },

    selectResponsibleListUpdate: function () {
      this.selectResponsibleList = this.user_setup.mediaResponsible.map(
        (idUser) => {
          let user = this.settings.data_user.find((el) => el.ID == idUser);
          return {
            id: user.ID,
            name: user.LAST_NAME + " " + user.NAME,
          };
        }
      );
    },
    selectAssignedListUpdate: function () {
      this.selectAssignedList = this.user_setup.mediaAssigned.map((idUser) => {
        let user = this.settings.data_user.find((el) => el.ID == idUser);
        return {
          id: user.ID,
          name: user.LAST_NAME + " " + user.NAME,
        };
      });
    },

    updateMediaList() {
      let sort = {};
      getMediaListSort(sort)
        .done((data) => {
          let item = data == "" ? {} : JSON.parse(data);
          this.setTypPrzychodu(item.TypArrival);
          this.setPlatnik(item.Platnik);
          for (let i in item.TypArrival) {
            let el = item.TypArrival[i];
            if (el.VALUE == "FVS PPC AdWords Media") {
              this.typeArrival[el.ID] = {
                name: "UF_CRM_ADV_MEDIA",
              };
            }
            if (el.VALUE == "FVS PPC FB Media") {
              this.typeArrival[el.ID] = {
                name: "UF_CRM_FB_MEDIA",
              };
            }
            if (el.VALUE == "FVS PPC Inni Wyd. Media") {
              this.typeArrival[el.ID] = {
                name: "UF_CRM_INNI_MEDIA",
              };
            }
            if (el.VALUE == "FVS SM Media") {
              this.typeArrival[el.ID] = {
                name: "UF_CRM_SM_MEDIA",
              };
            }
          }
        })
        .fail((e) => {
          console.err(e);
          this.$message.error(this.$t("Error loading document"));
        });
      getMediaListForecastsSort(sort)
        .done((data) => {
          let item = data == "" ? {} : JSON.parse(data);
          this.setProject(item.project);
        })
        .fail((e) => {
          console.err(e);
          this.$message.error(this.$t("Error loading document"));
        });
    },
    sortMediaList: function () {
      let sort = {};
      this.sortActive = "";
      for (let key in this.sort) {
        if (this.sort[key] != "") {
          if (key == "checkOnPlanned") {
            sort.checkOnPlanned = this.sort[key];
          }
          if (key == "checkPlanned") {
            sort.checkPlanned = this.sort[key];
          }
          if (key == "selectData") {
            if (this.sort[key] != null) {
              sort.year = this.getYear(this.sort[key]);
              sort.month = this.getMountNumber(this.sort[key]);
              this.sortActive +=
                this.sortActive == ""
                  ? this.getYear(this.sort[key]) +
                    "-" +
                    moment(this.sort[key]).format("MM")
                  : ", " +
                    this.getYear(this.sort[key]) +
                    "-" +
                    moment(this.sort[key]).format("MM");
            }
          }
          if (key == "selectOpiekun") {
            sort.opiekunCS = this.sort[key];
            this.sortActive +=
              this.sortActive == ""
                ? this.searchUser(this.sort[key])
                : ", " + this.searchUser(this.sort[key]);
          }
          if (key == "selectPlatnik") {
            sort.platnik = this.sort[key];
            this.sortActive +=
              this.sortActive == ""
                ? this.searchPlatnik(this.sort[key])
                : ", " + this.searchPlatnik(this.sort[key]);
          }
          if (key == "selectProject") {
            sort.project = this.sort[key];
            this.sortActive +=
              this.sortActive == ""
                ? this.selectProject.find((el) => el.id == this.sort[key]).name
                : ", " +
                  this.selectProject.find((el) => el.id == this.sort[key]).name;
          }
          if (key == "selectSpejalista") {
            sort.specjalista = this.sort[key];
            this.sortActive +=
              this.sortActive == ""
                ? this.searchUser(this.sort[key])
                : ", " + this.searchUser(this.sort[key]);
          }
          if (key == "selectTypPrzychodu") {
            sort.typPrzychodu = this.sort[key];
            this.sortActive +=
              this.sortActive == ""
                ? this.searchTypeArrival(this.sort[key])
                : ", " + this.searchTypeArrival(this.sort[key]);
          }
        }
      }

      getMediaListForecastsSort(sort)
        .done((data) => {
          this.$message.info(this.$t("Download complete!"));
          let item = data == "" ? {} : JSON.parse(data);

          let indexMediaList = -1;
          this.MediaListSource = [];
          for (let i in item.project) {
            let deal = item.project[i];
            this.MediaListSource = this.MediaListSource.concat(
              deal.info.map((el) => {
                indexMediaList++;
                let summ =
                  (el["summType"] ? el["summType"] : 0) -
                  (el["summTypeKoszt"] ? el["summTypeKoszt"] : 0);
                return {
                  key: indexMediaList,
                  dataY: el.year,
                  dataM: el.month,
                  id: el.dealID,
                  project: el.DEAL_TITLE,
                  kontrahent: el.DEAL_COMPANY_ID,
                  typPrzychodu: el.typeArrival,
                  platnik: el.payer,
                  specjalista: el.ASSIGNED_BY_ID,
                  opiekunCS: el.responsible,
                  plan: el.plan,
                  komentarz: el.DEAL_COMMENTS,
                  performed: el.performed,
                  previousPlan: el.previousPlan,
                  editMode: false,
                  summType: el["summType"] ? el["summType"] : "",
                  summTypeKoszt: el["summTypeKoszt"] ? el["summTypeKoszt"] : "",
                  summ,
                  invoices: el.invoices
                };
              })
            );
          }
          this.seachMenuView = false;
        })
        .fail((e) => {
          console.err(e);
          this.$message.error(this.$t("Error loading document"));
        });
      BX24.fitWindow();
    },

    getSelectUserList: function () {
      return this.settings.data_user.map((user) => ({
        id: user.ID,
        name: user.LAST_NAME + " " + user.NAME,
      }));
    },

    searchTypeArrival: function (idTypeArrival) {
      let typeArrival = this.selectTypPrzychoduList.find((type) => {
        return type.id == idTypeArrival;
      });
      return typeArrival ? typeArrival.name : "";
    },
    searchPlatnik: function (idPlatnik) {
      let platnik = this.selectPlatnik.find((type) => {
        return type.id == idPlatnik;
      });
      return platnik ? platnik.name : "";
    },
    searchCompany: function (idCompany) {
      let company = this.settings.company.find((company) => {
        return company.ID == idCompany;
      });
      return company ? company.TITLE : "";
    },
    searchUser: function (idUser) {
      let user = this.settings.data_user.find((user) => {
        return user.ID == idUser;
      });
      return user ? user.LAST_NAME + " " + user.NAME : "";
    },
    getYear: function (data) {
      return moment(data).format("YYYY");
    },
    getMount: function (data) {
      return moment(data, "MM").format("MMMM");
    },
    getMountNumber: function (data) {
      return moment(data).format("M");
    },
    sortReset: function () {
      for (let key in this.sort) {
        if (key == "checkOnPlanned" || key == "checkPlanned") {
          this.sort[key] = false;
        } else {
          this.sort[key] = "";
        }
      }
    },

    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    clearSelect: function (nameSelect) {
      this.sort[nameSelect] = "";
    },

    editPerformed: function (key) {
      this.MediaListSource.find((el) => el.key == key)["editMode"] = true;
    },
    savePerformed: function (key) {
      let item = this.MediaListSource.find((el) => el.key == key);


      let project = {
        id: item.id,
        year: item.dataY,
        month: item.dataM,
        performed: item.performed,
        typeArrival: this.typeArrival[item.typPrzychodu].name,
      };
      postEditPerformed(project)
        .done(() => {
          this.$message.info(this.$t("Download complete!"));

          this.sortMediaList();
        })
        .fail((e) => {
          console.err(e);
          this.$message.error(this.$t("Error loading document"));
        });
      this.MediaListSource.find((el) => el.key == key)["editMode"] = false;
    },

    openFacture: function (mediaList) {
      this.$emit("openFacture", mediaList);
    },

    changeStatusEdit: function () {
      let userEditActive = [...this.user_setup.mediaResponsible].concat([
        ...this.user_setup.mediaAssigned,
      ]);
      this.statusEdit = Boolean(
        userEditActive.find((el) => el == this.USER_ACTIVE.ID)
      );
    },

    openSalesTable: function (data) {
      data.filter = this.sort;
      this.$emit("openSalesTable", data);
    },
    openInvoice: function (invoice) {


      this.$emit("openInvoice", {invoice, sort: this.sort});
    },
  },
  mounted() {
    this.changeStatusEdit();

    if (this.statusEdit) {
      this.sort.selectSpejalista = this.USER_ACTIVE.ID;
      this.sort.selectData = moment();
    } else {
      this.sort.selectData = moment();
    }
    this.selectUserList = this.getSelectUserList();
    this.selectWorker = this.selectUserList[0].id;
    this.selectData = moment();
    if (this.checkFacture) {
      this.sort = this.dataFacture.filter;
    }
    this.updateMediaList();
    this.sortMediaList();
    this.selectResponsibleListUpdate();
    this.selectAssignedListUpdate();
    BX24.fitWindow();
  },
};
</script>

<style scoped>
.manager-panel {
  margin: 10px 0;
}
.list-invoices {
  max-height: 65px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow-y: scroll;
}
</style>
